import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { PATH_TO_MODULE } from "../constants/modules";
import { ROUTES } from "../constants/routes";

const ProtectedRoute = ({ allowedRoles }) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  const currentPath = location.pathname;

  const role = user?.roleName?.toLowerCase() || localStorage.getItem("lastRole");
  const roleLoginRoutes = {
    admin: "/login",
  };

  const loginRedirectPath = roleLoginRoutes[role] || "/login";
  const getFlattenedRoutes = (routes = []) => {
    const flattened = [];

    routes.forEach((route) => {
      flattened.push({
        path: route.routePath,
        canView: route.canView,
      });

      if (route.children && Array.isArray(route.children)) {
        route.children.forEach((sub) => {
          flattened.push({
            path: `${sub.routePath}`,
            canView: sub.canView,
          });
        });
      }
    });
    
    return flattened;
  };
  const accessibleRoutes = getFlattenedRoutes(user?.routes || []);
  const matchedRoute = accessibleRoutes.find((r) => r.path === currentPath);
  if (!isAuthenticated) {
    return <Navigate to={loginRedirectPath} state={{ from: location }} replace />;
  }
  if (allowedRoles && !allowedRoles.includes(user?.roleName?.toLowerCase()) || !matchedRoute || !matchedRoute.canView) {
    return <Navigate to={ROUTES.UNAUTHORIZED} replace />;
  }
  return <Outlet />;
};

export default ProtectedRoute;
